import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Login from "@/components/login/Login";
import Adminman from "@/components/login/Adminman";
import LessonAdd from "@/components/LessonAdd";
import LessonEdit from "@/components/LessonEdit";
import LessonDetail from "@/components/teacher/LessonDetail";
import ItemDetail from "@/components/ItemDetail";
import LessonStudent from "@/components/teacher/LessonStudent";
import LessonDetailPublic from "@/components/LessonDetailPublic";
import LessonGrid from "@/components/LessonGrid";
import Dashboard2 from "@/components/Dashboard2";
import Dashboard from "@/components/Dashboard";
import TopicStat from "@/components/TopicStat";
import Questions from "@/components/Questions";
import QuestionAdd from "@/components/QuestionAdd";
import Asuulga from "@/components/Asuulga";
import QAPage from "@/components/QAPage";
import QuestionsAnswer from "@/components/QuestionsAnswer";
import LessonQuestionAdd from "@/components/LessonQuestionAdd";

import SelbegTypes from "@/components/category/SelbegTypes";
import SelbegTypes2 from "@/components/category/SelbegTypes2";
import SelbegTypes3 from "@/components/category/SelbegTypes3";

import PublicQA from "@/components/PublicQA";
import Students from "@/components/Students";
import StudentAdd from "@/components/StudentAdd";
import Teachers from "@/components/Teachers";
import TeacherAdd from "@/components/TeacherAdd";
import LessonQA from "@/components/LessonQA";
import Register from "@/components/login/Register";
import AddInfo from "@/components/login/AddInfo";
import AllLessons from "@/components/AllLessons";
import DetailQuestions from "@/components/teacher/Questions";
import DetailQuestionAdd from "@/components/teacher/QuestionAdd";
import SimpleQuestionAdd from "@/components/teacher/SimpleQuestionAdd";
import ImageAdd from "@/components/ImageAdd";
import StudentDetail from "@/components/student/StudentDetail";
import LessonAttendance from "@/components/teacher/LessonAttendance";
import SCarsCategoryAdd from "@/components/admin/SCarsCategoryAdd";
import CarCategories from "@/components/admin/CarCategories";
import CarMarks from "@/components/admin/CarMarks";
import Aral from "@/components/admin/Aral";
import AralYears from "@/components/admin/AralYears";
import StudentsAdd from "@/components/admin/StudentsAdd";
import HomeLogin from "@/components/login/HomeLogin";
import TeacherLogin from "@/components/login/TeacherLogin";
import LessonDetailAdmin from "@/components/admin/LessonDetailAdmin";
import UserProfile from "@/components/login/UserProfile";
import TestResult from "@/components/student/TestResult";
import firebase from "firebase";
import { store } from "../store.js";

import ACategories from "@/components/ACategories";
import Cars from "@/components/cars/Cars";
import CarAdd from "@/components/cars/CarAdd";
import CarDetails from "@/components/cars/CarDetails";

import PendingStores from "@/components/admin/PendingStores";
import RoleRequests from "@/components/admin/RoleRequests";
import ItemFindRequest from "@/components/admin/ItemFindRequest";
import Stores from "@/components/admin/Stores";
import Users from "@/components/admin/Users";

import ItemDeleteRequest from "@/components/admin/ItemDeleteRequest";
import GlobalAlerts from "@/components/admin/GlobalAlerts";
import StoreFindRequests from "@/components/admin/StoreFindRequests";
import FeedBack from "@/components/admin/FeedBack";
import Countries from "@/components/address/Countries";
import Cities from "@/components/address/Cities";
import Districts from "@/components/address/Districts";
import Khoroos from "@/components/address/Khoroos";
import CategoryItems from "@/components/client/CategoryItems";
import SubCategoryItems from "@/components/client/SubCategoryItems";
import StoreItems from "@/components/client/StoreItems";
import CheckItems from "@/components/admin/CheckItems";
import FilterByCartype from "@/components/client/FilterByCartype";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [

    {
      path: "/detail/:xpath/:title",
      name: "IProductDetailView",
      component: () => import('@/views/IProductDetailView'),
      meta: {
        requiresAuth: false
      },
      props: true,
    },
    {
      path: "/login",
      name: "Login",
      component: HomeLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/studentlogin",
      name: "StudentLogin",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/teacherlogin",
      name: "TeacherLogin",
      component: TeacherLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/adminman",
      name: "Adminman",
      component: Adminman,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "*",
      redirect: "/dashboard"
    },
    {
      path: "/cars",
      name: "Car",
      component: Cars,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/lessonadd/:storeId",
      name: "LessonAdd",
      component: LessonAdd,
      props: true,
      meta: {
        requiresAuth: true,
        // authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/addcar",
      name: "CarAdd",
      component: CarAdd,
      props: false,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/lessonedit/:lessonId",
      name: "LessonEdit",
      component: LessonEdit,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonDetail,
      name: "LessonDetail",
      path: "/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonStudent,
      name: "LessonStudent",
      path: "/lesson/:lessonId/students",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonAttendance,
      name: "LessonAttendance",
      path: "/lesson/:lessonId/attendance",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonGrid,
      name: "LessonGrid",
      path: "/lessons",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    {
      component: LessonDetailPublic,
      name: "LessonDetailPublic",
      path: "/public/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    {
      component: LessonDetailAdmin,
      name: "LessonDetailAdmin",
      path: "/admin/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: Dashboard,
      name: "Dashboard",
      path: "/",
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      component: Dashboard2,
      name: "Dashboard2",
      path: "/dashboard2",
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      component: CategoryItems,
      name: "CategoryItems",
      path: "/category/:categoryId",
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      component: SubCategoryItems,
      name: "SubCategoryItems",
      path: "/category/:categoryId/:typeId",
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      component: StoreItems,
      name: "StoreItems",
      path: "/store/:storeId",
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      component: FilterByCartype,
      name: "FilterByCartype",
      path: "/filter/cartype",
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      component: TopicStat,
      name: "TopicStat",
      path: "/public/lesson/:lessonId/:type/:topicId",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: Asuulga,
      name: "Asuulga",
      path: "/qa",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: QAPage,
      name: "QAPage",
      path: "/qapage",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: Questions,
      name: "Questions",
      path: "/qa/:qaId/questions",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: QuestionsAnswer,
      name: "QuestionsAnswer",
      path: "/qa/:qaId/answer",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/qa/:qaId/questionadd/:questionId",
      name: "QuestionAdd",
      component: QuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/private/:path/:questionId",
      name: "LessonQuestionAdd",
      component: LessonQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: SelbegTypes,
      name: "SelbegTypes",
      path: "/selbegtypes",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/selbegtypes/:schoolId",
      name: "SelbegTypeDetail",
      component: SelbegTypes2,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/selbegtypes/:schoolId/children/:departmentId",
      name: "SelbegSubTypeDetail",
      component: SelbegTypes3,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/publicqa",
      name: "PublicQA",
      component: PublicQA,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/students",
      name: "Students",
      component: Students,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: StudentDetail,
      name: "StudentDetail",
      path: "/student/:studentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/studentadd/:studentId",
      name: "StudentAdd",
      component: StudentAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/teachers",
      name: "Teachers",
      component: Teachers,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/teacheradd/:teacherId",
      name: "TeacherAdd",
      component: TeacherAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
	},
  {
		path: "/pending",
		name: "PendingStores",
		component: PendingStores,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/requests",
		name: "RoleRequests",
		component: RoleRequests,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/findrequest",
		name: "ItemFindRequest",
		component: ItemFindRequest,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/alerts",
		name: "GlobalAlerts",
		component: GlobalAlerts,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/stores",
		name: "Stores",
		component: Stores,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/userslist",
		name: "Users",
		component: Users,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
  {
		path: "/carscategory",
		name: "CarCategories",
		component: CarCategories,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/:cartypeId/carmarks",
		name: "CarMarks",
    component: CarMarks,
    props:true,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
  {
		path: "/carscategory/:categoryId/add",
		name: "SCarsCategoryAdd",
    component: SCarsCategoryAdd,
    props:true,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/aral/add",
		name: "Aral",
    component: Aral,
    props:true,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
  },
  {
		path: "/aral/years",
		name: "AralYears",
    component: AralYears,
    props:true,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
	{
		path: "/studentsadd",
		name: "StudentsAdd",
		component: StudentsAdd,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
    {
      path: "/lessonqa/:lessonId",
      name: "LessonQA",
      component: LessonQA,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/addinfo",
      name: "AddInfo",
      component: AddInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/alllessons",
      name: "AllLessons",
      component: AllLessons,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/:detailId",
      name: "DetailQuestions",
      component: DetailQuestions,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/questionadd/:detailPath/:categoryId/:questionId",
      name: "DetailQuestionAdd",
      component: DetailQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/simplequestionadd/:detailPath/:categoryId/:questionId",
      name: "SimpleQuestionAdd",
      component: SimpleQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/imageadd/:objectPath",
      name: "ImageAdd",
      props: true,
      component: ImageAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/userprofile",
      name: "UserProfile",
      component: UserProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stat/lesson/:lessonId/topic/:topicId/:contentId",
      name: "TestResult",
      component: TestResult,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: ACategories,
      name: "ACategories",
      path: "/categories",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: CarDetails,
      name: "CarDetails",
      path: "/cars/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: ItemDetail,
      name: "ItemDetail",
      path: "/item/:selbegPath",
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: ItemDeleteRequest,
      name: "ItemDeleteRequest",
      path: "/items/deleterequest",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: StoreFindRequests,
      name: "StoreFindRequests",
      path: "/store/findrequest",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: FeedBack,
      name: "FeedBack",
      path: "/feedback",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: Countries,
      name: "Countries",
      path: "/countries",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: Cities,
      name: "Cities",
      path: "/cities/:countryId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: Districts,
      name: "Districts",
      path: "/districts/:countryId/:schoolId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: Khoroos,
      name: "Khoroos",
      path: "/khoroos/:countryId/:schoolId/:districtId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      component: CheckItems,
      name: "CheckItems",
      path: "/check/admin",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
  ],
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const authorize = to.meta.authorize;
  const currentUser = firebase.auth().currentUser;

  // const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  // const currentUser = firebase.auth().currentUser

  if (store.getters.enabled == true) {
    // if (requiresAuth && !currentUser) {
    // 	next('/login')
    // } else if (requiresAuth && currentUser) {
    // 	next()
    // }
    // else if (requiresAuth==false) {
    // 	next()
    // }
    // else
    // 	next('/login')
    if (authorize != undefined) {
      if (requiresAuth && !currentUser) {
        next("/login");
      } else if (requiresAuth && currentUser) {
        if (
          authorize != null &&
          authorize.length > 0 &&
          store.getters.userProfile != null &&
          store.getters.userProfile.role != null &&
          authorize.includes(store.getters.userProfile.role)
        ) {
          next();
        } else {
          next("/");
        }
      } else if (requiresAuth == false) {
        next();
      } else next("/login");
    } else {
      if (requiresAuth && !currentUser) {
        next("/login");
      } else if (requiresAuth && currentUser) {
        next();
      } else if (requiresAuth == false) {
        next();
      } else next("/login");
    }
  } else {
    if (requiresAuth && !currentUser) {
      next("/login");
    } else if (requiresAuth && currentUser) {
      if (to.name != "AddInfo") {
        next("/addinfo");
      } else next();
    } else if (requiresAuth == false) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
